import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
            <h1 className="text-3xl font-extrabold text-gray-900">Privacy Policy</h1>
            <p className="mt-4 text-lg text-gray-500 leading-loose">
                Who we are <br />
                <span className='text-sm'>Our website address is: <Link to='https://wehatbazar.com' className='text-blue-500'>https://wehatbazar.com</Link></span> <br />
                What personal data we collect and why we collect it
            </p>
            <h2 className="mt-6 text-xl font-medium text-gray-900">Comments</h2>
            <p className="mt-4 text-lg text-gray-500 text-justify">
                When visitors leave comments on the site we collect the data shown in the comments form, and also the visitor’s IP address and browser user agent string to help spam detection.
                An anonymized string created from your email address (also called a hash) may be provided to the Gravatar service to see if you are using it. The Gravatar service privacy policy is available here: <a href="https://automattic.com/privacy/" className='text-blue-500'>https://automattic.com/privacy/</a>. After approval of your comment, your profile picture is visible to the public in the context of your comment.

            </p>

            <h2 className="mt-6 text-xl font-medium text-gray-900">Media</h2>
            <p className="mt-4 text-lg text-gray-500 text-justify">
                If you upload images to the website, you should avoid uploading images with embedded <br />
                location data (EXIF GPS) included. Visitors to the website can download and extract any <br />
                location data from images on the website.
            </p>

            <h2 className="mt-28 text-2xl font-medium text-gray-900">Contact Forms</h2>
            <h2 className="mt-6 text-xl font-medium text-gray-900">Cookies</h2>
            <p className="mt-4 text-lg text-gray-500 text-justify">
                If you leave a comment on our site you may opt-in to saving your name, email address and website in cookies. These are for your convenience so that you do not have to fill in your details again when you leave another comment. These cookies will last for one year.
            </p>
            <p className="mt-5 text-lg text-gray-500 text-justify">
                If you visit our login page, we will set a temporary cookie to determine if your browser accepts cookies. This cookie contains no personal data and is discarded when you close your browser.
            </p>
            <p className="mt-6 text-lg text-gray-500 text-justify">
                When you log in, we will also set up several cookies to save your login information and your screen display choices. Login cookies last for two days, and screen options cookies last for a year. If you select “Remember Me”, your login will persist for two weeks. If you log out of your account, the login cookies will be removed.
            </p>
            <p className="mt-6 text-lg text-gray-500">
                If you edit or publish an article, an additional cookie will be saved in your browser. This cookie includes no personal data and simply indicates the post ID of the article you just edited. It expires after 1 day.
            </p>



            <h2 className="mt-6 text-xl font-medium text-gray-900">Embedded content from other websites</h2>
            <p className="mt-4 text-lg text-gray-500 text-justify">
                Articles on this site may include embedded content (e.g. videos, images, articles, etc.). Embedded content from other websites behaves in the exact same way as if the visitor has visited the other website.
            </p>
            <p className="mt-8 text-lg text-gray-500 text-justify">
                These websites may collect data about you, use cookies, embed additional third-party tracking, and monitor your interaction with that embedded content, including tracking your interaction with the embedded content if you have an account and are logged in to that website.
            </p>


            <h2 className="mt-6 text-xl font-medium text-gray-900">Analytics</h2>
            <p className="mt-4 text-lg text-gray-500 text-justify leading-loose">
                Who We share your data with <br />
                How long we retain your data
            </p>

            <p className="mt-4 text-sm text-gray-500 text-justify leading-loose">
                If you leave a comment, the comment and its metadata are retained indefinitely. This is so we can recognize and approve any follow-up comments automatically instead of holding them in a moderation queue.
            </p>
            <p className="mt-4 text-sm text-gray-500 text-justify leading-loose">
                For users that register on our website (if any), we also store the personal information they provide in their user profile. All users can see, edit, or delete their personal information at any time (except they cannot change their username). Website administrators can also see and edit that information.
            </p>


            <h2 className="mt-6 text-xl font-medium text-gray-900">What rights you have over your data</h2>
            <p className="mt-4 text-lg text-gray-500 text-justify">
                If you have an account on this site, or have left comments, you can request to receive an exported file of the personal data we hold about you, including any data you have provided to us. You can also request that we erase any personal data we hold about you. This does not include any data we are obliged to keep for administrative, legal, or security purposes.
            </p>


            <h2 className="mt-6 text-xl font-medium text-gray-900">Where we send your data</h2>
            <p className="mt-4 text-lg text-gray-500 text-justify">
                Visitor comments may be checked through an automated spam detection service.
            </p>



            <h2 className="mt-6 text-xl font-medium text-gray-900">How we protect your data</h2>
            <h2 className="mt-6 text-xl font-medium text-gray-900">What data breach procedures we have in place</h2>
            <h2 className="mt-6 text-xl font-medium text-gray-900">What third parties we receive data from</h2>
            <h2 className="mt-6 text-xl font-medium text-gray-900">What automated decision making and/or profiling we do with user data</h2>
            <h2 className="mt-6 text-xl font-medium text-gray-900">Industry regulatory disclosure requirements</h2>
        </div>
    );
};

export default PrivacyPolicy;